import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { AppMetaDataLookups, UserTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../services/admin-manager.service';


@DwComponent({
  key: 'sc-set-user-type',
   name: 'Set User Type',
   isGlobal: true,
   componentType: DwComponentType.menuComponent
})
@Component({
  selector: 'app-set-user-type',
  template: `
    <div class="dropdown-item2" style="padding:10px" *ngIf="canSetUserType">
         Set User Type

           <dw-radio-lookup [(ngModel)]="adminUserTypeId" (ngModelChange)="onMenuClick($event)"
                [lookupId]="userTypeLookupId"></dw-radio-lookup>
    </div>
  `
})
export class UserTypeMenuComponent implements OnInit {
  userTypeLookupId = AppMetaDataLookups.UserTypeAllItems;
  adminUserTypeId: any;
  canSetUserType: boolean;

  constructor(private adminManagerService: AdminManagerService) { }

  ngOnInit(): void {

    this.canSetUserType = this.adminManagerService.canUseAdminProperties();

    const user = this.adminManagerService.getPilexosUser();

    this.adminUserTypeId = user.UserTypeId;
  }

  onMenuClick(event: any) {
    this.adminManagerService.updateAdminProperties({
      userTypeMode: this.adminUserTypeId // this.showAdminType ? UserTypeAllItems.Student : UserTypeAllItems.FlightInstructor
    });
  }

}
